const React = require("react");

const viewport$ = require("mn-utils/browser/emitters/viewport");
const formatTime = require("mn-utils/formatTime");
const withReDelay = require("mn-utils/withReDelay");
const delay = require("mn-utils/delay");

const {paramStore} = require("../../../../../../stores");
const {intervals, getDateRange, IntervalFilterMerchant} = require("../../../../../dumb/IntervalFilterCustom");
const {apiAdminPaymentList, apiAdminTransactionsList} = require("../../../../../../api/merchant/transactions");
const Caption = require("../../../../../dumb/Caption/C");
const {STATUSES_FILTER_SELECT} = require("../../../../../../constants/statusesTrx");
const Col = require("../../../../../dumb/Col/C");
const TableItem = require("./TableItem");
const router = require("../../../../../../router");

const filter$ = paramStore('filter', {
  interval: intervals.INTERVAL_YEAR,
});

module.exports = require('../../../../../../utils/virtualOutputComponentProvider')({
  state: {
    filter: filter$,
    viewport: viewport$.throttle(100),
  },
  rowHeight: 70,
  nodata: (<div
    className="f16 fw4 cC mt20 ttU tc w"
  >No data</div>),
  request: apiAdminTransactionsList,
  getParams: (self) => {
    const filter = self.state.filter;
    const withdrawal_id = self.props.id;

    const {
      from,
      to,
    } = getDateRange(filter);

    const dateMask = '{yyyy}-{mm}-{dd}';

    return {
      withdrawal_id,
      search: filter.search || null,
      from: from && formatTime(from, dateMask),
      to: to && formatTime(to, dateMask),
      transaction_type: filter.transactionType || null,
      lifeflow: filter.lifeflow || null,
    };
  },
  wrapper(render, setState, self) {
    const update = withReDelay(self.update, 1000);
    function handleChangeFilter(filter) {
      filter$.emit({
        ...self.state.filter,
        ...filter,
      });
      update();
    }

    let _nodeHeader;
    function onRefHeader(node) {
      node && _nodeHeader !== node && (
        _nodeHeader = node,
          delay(setState, 0, [{}])
      );
    }

    return (state) => {
      const filter = state.filter;
      const noData = !state.data || !state.data.count;

      return (
        <div>
          <div ref={onRefHeader}>
            <div className="layoutRow fhaB fvaC">
              <Caption
                data-testid="titleTrx"
              >
                Payments history
              </Caption>
            </div>
            <IntervalFilterMerchant
              className="mv13"
              data={filter}
              onChange={handleChangeFilter}
              report={{
                prefix: 'merchant-payments',
                url: '/f2c/v1/console/transactions/'
              }}
              update={self.update}
              search={{
                placeholder: 'Search by Email / TRX ID / Amount',
              }}
            />
          </div>
          <div className="hmin320 h100vh-600 rlv h100vh-340@m">
            <div className="h abs sh ov">
              <div className="h abs s ov ovxA">
                <div className="wmin600 rlv h">
                  <div className="bg717275 layoutRow fhaC fvaC ov ph20 w1/6>1">
                    <Col>Type</Col>
                    <Col>Email</Col>
                    <Col>App Url</Col>
                    <Col>External TRX ID</Col>
                    <Col>Date</Col>
                    <Col>Amount</Col>
                  </div>
                  <div className="abs sh st45 sb ovH c0>.CircularProgress">
                    {render(TableItem)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };
  },
});
